// Simple shim that is a no op since the real VM2 is nodejs only.
// It is never used but is a dependency
var VM2 = (exports.VM2 = function VM2() {});

VM2.prototype.run = function(conditions) {
    console.log(conditions);
};
